import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yx_icon_down",
  "use": "icon-yx_icon_down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yx_icon_down\"><path d=\"M256 338.773333l256 256 256-256L813.226667 384l-278.613334 278.613333a32 32 0 0 1-45.226666 0L210.773333 384 256 338.773333z\" p-id=\"1676\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/svg/yx_icon_down.svg
// module id = Juze
// module chunks = 76